import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tab,
  Tabs,
} from "@mui/material";
import SwitchToggle from "../../components/SwitchToggle";
import UserSubscriptionWithLogs from "../../features/manageCustomers/userSubscriptionWithLogs";
import LinkedAccountsTable from "../../features/manageCustomers/linkedAccountsTable";
import TaskViewList from "../../features/manageCustomers/taskViewList";
import BudgetStatsView from "../../features/manageCustomers/budgetStatsView";
import { useLazyGetFamilyByIdQuery } from "../../services/sharedAccount";
import { showError } from "../../constants/toasts";
import {
  useLazyGetUserExpenseByIdQuery,
  useLazyGetUserTasksByIdQuery,
} from "../../services/user";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageSharedAccountDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [valueTabs, setValueTabs] = React.useState(0);
  const [tasks, setTasks] = useState<any>(null);
  const [expenses, setExpenses] = useState<any>(null);
  const [getUserExpenseById] = useLazyGetUserExpenseByIdQuery();
  const [getById] = useLazyGetFamilyByIdQuery();
  const [getUserTaskById] = useLazyGetUserTasksByIdQuery();

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [Status, setStatus] = React.useState("Active");
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };

  const [getDeatils] = useLazyGetFamilyByIdQuery();
  const [loading, setLoading] = useState<boolean>();

  const getDataByIdList = async () => {
    try {
      setLoading(true);
      if (!id) return;
      const response = await getDeatils({ id: Number(id) }).unwrap();
      if (response.status === 200) {
        console.log(response, "list response");
      }

      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      showError(error?.message || error?.data?.message);
    }
  };
  const getTasksById = async () => {
    try {
      setLoading(true);
      if (!id) return;
      const numericId = Number(id);
      if (Number.isNaN(numericId)) return;
      const response = await getUserTaskById({ id: numericId }).unwrap();

      if (
        (response as any).status === 200 ||
        (response as any).statusCode === 200
      ) {
        setTasks((response as any).data);
      }
      setLoading(false);
      console.log(tasks, "Tasks");
    } catch (error: any) {
      setLoading(false);
      showError(error?.message || error?.data?.message);
    }
  };

  const getExpensesById = async () => {
    try {
      setLoading(true);
      if (!id) return;
      const numericId = Number(id);
      if (Number.isNaN(numericId)) return;
      const response = await getUserExpenseById({ id: numericId }).unwrap();
      if (
        (response as any).status === 200 ||
        (response as any).statusCode === 200
      ) {
        setExpenses((response as any).data);
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      showError(error?.message || error?.data?.message);
    }
  };

  useEffect(() => {
    if (id) {
      getDataByIdList();
      getTasksById();
      getExpensesById();
    }
  }, [id]);
  return (
    <>
      <div className="main_title">
        <h1>Shared Account Details</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
          <span onClick={() => navigate("/manage-shared-accounts")}>
            Family / Shared Account Manager
          </span>{" "}
          - Shared Account Detail
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Tasks" {...a11yProps(0)} />
              <Tab label="Budget Stats" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div>

      {/* Task */}
      <CustomTabPanel value={valueTabs} index={0}>
        <div className="cards view_page">
          <div className="section_title">
            <h2>Tasks</h2>
          </div>
          <TaskViewList tasks={tasks?.response_object || []} />
        </div>
      </CustomTabPanel>

      {/* Budget Stats */}
      <CustomTabPanel value={valueTabs} index={1}>
        <div className="stats_boxes gap_m">
          <div className="cards">
            <figure>
              <img src="/static/images/money_icon.svg" alt="" />
            </figure>
            <h2>AED {expenses?.total_expense_sum}</h2>
            <p>Expense</p>
          </div>
          <div className="cards">
            <figure>
              <img src="/static/images/money_icon.svg" alt="" />
            </figure>
            <h2>AED 1000</h2>
            <p>My Budget</p>
          </div>
        </div>
        <BudgetStatsView expenseData={expenses}/>
      </CustomTabPanel>
    </>
  );
};

export default ManageSharedAccountDetail;
